import React, { useContext, useEffect, useMemo, useState } from "react";
const JitsiWrapperContext = React.createContext({
  available: false,
  loaded: false,
  url: ""
});
export const JitsiWrapper = ({ url, children }) => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const script = Object.assign(document.createElement("script"), {
      src: `${url}/external_api.js`,
      async: true,
      defer: true
    });
    script.onload = () => {
      setLoaded(true);
    };
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [url]);
  return /* @__PURE__ */ React.createElement(JitsiWrapperContext.Provider, { value: { available: true, loaded, url } }, children);
};
export const useJitsi = () => {
  return useContext(JitsiWrapperContext);
};
export const jitsiOptionDefaults = {
  width: "100%",
  height: "100%",
  noSSL: false
};
export const JitsiRoom = (props) => {
  const { loaded } = useContext(JitsiWrapperContext);
  const { domain, apiChanged } = props;
  const options = useMemo(() => {
    return JSON.stringify({ ...jitsiOptionDefaults, ...props.options });
  }, [props.options]);
  const id = props.id || "jitsi";
  useEffect(() => {
    if (!loaded) {
      return;
    }
    const api = new JitsiMeetExternalAPI(domain, {
      parentNode: document.querySelector(`#${id}`),
      ...JSON.parse(options)
    });
    apiChanged && apiChanged(api);
    return () => {
      api?.dispose();
    };
  }, [loaded, id, options, domain, apiChanged]);
  return /* @__PURE__ */ React.createElement("div", { id, style: props.style || {} });
};
//# sourceMappingURL=index.js.map
